import {
  Button as ChakraButton,
  Spinner,
} from '@chakra-ui/react'
import React, { type ComponentProps, forwardRef } from 'react'

interface Props extends ComponentProps<typeof ChakraButton> {
  icon?: React.ReactNode
  rightIcon?: React.ReactNode
}

export const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      colorPalette = 'hep',
      variant = 'solid',
      loading = false,
      children,
      disabled,
      icon,
      rightIcon,
      ...props
    },
    ref
  ) => {
    return (
      <ChakraButton
        ref={ref}
        variant={variant}
        colorPalette={colorPalette}
        disabled={loading || disabled}
        {...props}
      >
        {loading ? <Spinner /> : icon}
        {children}
        {loading || rightIcon}
      </ChakraButton>
    )
  }
)
